import { SITE_URL } from "./data";

// React 19 hoists <title>/<meta>/<link> into <head> natively. Prerendered HTML gets its head from src/prerender.jsx.
export const Seo = ({ title, description, path, image, jsonLd = [], noindex = false }) => {
  if (typeof window === "undefined") return null;
  const url = path ? `${SITE_URL}${path}` : null;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {url && <link rel="canonical" href={url} />}
      {noindex && <meta name="robots" content="noindex" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="JMS Technologies" />
      <meta property="og:locale" content="en_CA" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      {jsonLd.map((d, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(d) }} />
      ))}
    </>
  );
};
